import { Box, Flex, Square, Text, Icon, HStack, Spacer } from '@chakra-ui/react';
import Content from '~/containers/Content';

import { IoCartSharp } from 'react-icons/io5';

import cartSettlementSelector from '~/recoil/selectors/cartSettlement';
import { useRecoilValue } from 'recoil';

import formatPriceNumber from '~/utils/formatPriceNumber';

type FooterCartStatusBarProps = {
  onNavigate?: () => void;
};

export default function FooterCartStatusBar({ onNavigate }: FooterCartStatusBarProps) {
  const { total, itemAmount } = useRecoilValue(cartSettlementSelector);

  return (
    <Box>
      <Content>
        <Flex as="a" bgColor="secondary" p={5} onClick={onNavigate} cursor="pointer">
          <HStack>
            <Square py={1} px={2} borderRadius="5px" bgColor="neutral">
              <Text textAlign="center" fontWeight="bold" fontSize="sm" color="white">
                {itemAmount}
              </Text>
            </Square>
            <Text fontWeight="bold" color="white">
              {formatPriceNumber(total)}
            </Text>
          </HStack>

          <Spacer />

          <HStack>
            <Text fontWeight="bold" color="white">
              結帳
            </Text>
            <Icon as={IoCartSharp} color="white" boxSize="1.5rem" />
          </HStack>
        </Flex>
      </Content>
    </Box>
  );
}
